export default __webpack_public_path__ + "static/media/Home.9f3e68a3.svg";